import { render } from "./SedationPanel.vue?vue&type=template&id=114464cc&scoped=true"
import script from "./SedationPanel.vue?vue&type=script&lang=js"
export * from "./SedationPanel.vue?vue&type=script&lang=js"

import "./SedationPanel.vue?vue&type=style&index=0&id=114464cc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-114464cc"]])

export default __exports__